import React from 'react';
import { useTranslation } from 'react-i18next';
import useGame from '../hooks/useGame';

const MobileVideoButton = ({ className }) => {

  const { t } = useTranslation();
  const { isPlayingBackgroundMusic, toggleAudioState } = useGame();

  return (
    <div className={`pre-play ${className}`}>
      <div className="inner">
        {!isPlayingBackgroundMusic && (
          <span id="pre-sound" onClick={toggleAudioState} className="icon sound-mute" />
        )}
        {isPlayingBackgroundMusic && (
          <span id="pre-sound" onClick={toggleAudioState} className="icon sound" />
        )}

        <button id="video-start" className="default">
          <span className="icon play" />
          <span>{t('mobile.play_video')}</span>
        </button>
        <span className="video-skip" id="skip-to">{className === "final" ? t('mobile.skip_to_results') : t('mobile.skip_to_question')}</span>
      </div>
    </div>
  );
};

export default MobileVideoButton;
